import React from 'react'
import numeral from 'numeral'
import { useTranslation } from 'react-i18next'
import cn from 'classnames'

import styles from './styles.module.scss'

import { getCurrency } from '../../../helpers/currencies'
import { calculateMargin } from '../../../helpers/invoice'

import { CrossIcon, EyeIcon } from '../Icons'

const getAggregatedInfo = (items, vat, discount) => {
  const {totalAmount, totalTax, totalWorkTimes, totalExpenses, totalManualEntries} = items.reduce((acc, item) => {
    return {
      ...acc,
      totalAmount: acc.totalAmount + numeral(item.total_price).value(),
      totalTax: acc.totalTax + numeral(item.vat || 0).value(),
      totalWorkTimes: acc.totalWorkTimes + (item.type === 'work_time' ? numeral(item.unit_price * item.quantity).value() : 0),
      totalExpenses: acc.totalExpenses + (item.type === 'expense' ? numeral(item.unit_price * item.quantity).value() : 0),
      totalManualEntries: acc.totalManualEntries + (item.type === 'manual_entry' ? numeral(item.unit_price * item.quantity).value() : 0),
    }
  }, {
    totalAmount: 0,
    totalTax: 0,
    totalWorkTimes: 0,
    totalExpenses: 0,
    totalManualEntries: 0,
  })

  const margin = calculateMargin(items, discount)
  const totalNet = totalWorkTimes + totalExpenses + totalManualEntries - discount
  const totalVat = totalNet * vat / 100

  return {
    // totalAmount: numeral(Math.max(0, totalAmount - discount)).format('0.00'),
    // totalTax: numeral(totalTax).format('0.00'),
    totalAmount: numeral(totalNet + totalVat).format('0.00'),
    totalTax: numeral(totalVat).format('0.00'),
    totalWorkTimes: numeral(totalWorkTimes).format('0.00'),
    totalExpenses: numeral(totalExpenses).format('0.00'),
    totalManualEntries: numeral(totalManualEntries).format('0.00'),
    workTimesCount: items.filter(i => i.type === 'work_time').length,
    expensesCount: items.filter(i => i.type === 'expense').length,
    manualEntriesCount: items.filter(i => i.type === 'manual_entry').length,
    totalWorkHours: numeral(items.filter(i => i.type === 'work_time').reduce((acc, i) => acc + numeral(i.quantity).value(), 0)).format('0.00'),
    margin: numeral(margin).format('0.00'),
  }
}

const InvoiceFooter = ({ data, currency, discount, vat, onClear, onPreview }) => {
  const { t } = useTranslation()
  const aggregatedData = getAggregatedInfo(data, vat, discount)

  return (
    <div className={styles.container}>
      <div className={styles.section}>
        <div className={styles.badge}>{aggregatedData.workTimesCount}</div>
        <div>{t('Work entries')}:</div>
        <div><span>{aggregatedData.totalWorkHours}</span> hrs</div>
        &#8226;
        <div><span>{aggregatedData.totalWorkTimes}</span> {getCurrency(currency).symbol}</div>
      </div>
      <div className={styles.divider} />
      <div className={styles.section}>
        <div className={styles.badge}>{aggregatedData.expensesCount}</div>
        <div>{t('Expenses')}:</div>
        <div><span>{aggregatedData.totalExpenses}</span> {getCurrency(currency).symbol}</div>
      </div>
      <div className={styles.divider} />
      {
        aggregatedData.manualEntriesCount > 0
          ? <>
              <div className={styles.section}>
                <div className={styles.badge}>{aggregatedData.manualEntriesCount}</div>
                <div>{t('Manual entries')}:</div>
                <div><span>{aggregatedData.totalManualEntries}</span> {getCurrency(currency).symbol}</div>
              </div>
              <div className={styles.divider} />
            </>
          : null
      }
      <div className={cn(styles.section, styles.summary)}>
        <div>
          <div className={styles.row}><div className={styles.key}>{t('Margin')}:</div> <span style={{color: '#32BF1F'}}>{aggregatedData.margin}</span> <div style={{color: '#32BF1F'}}>{getCurrency(currency).symbol}</div></div>
          <div className={styles.row}><div className={styles.key}>{t('VAT total')}:</div> <span>{aggregatedData.totalTax}</span> {getCurrency(currency).symbol}</div>
          <div className={styles.row}><div className={styles.key}>{t('Invoice total')}:</div> <span>{aggregatedData.totalAmount}</span> {getCurrency(currency).symbol}</div>
        </div>
        {/* <div>
          <div>{t('Revenue')}: <span>{aggregatedData.revenue}</span> {getCurrency(currency).symbol}</div>
          <div>{t('VAT total')}: <span>{aggregatedData.totalTax}</span> {getCurrency(currency).symbol}</div>
        </div> */}
        <div className={styles.actions}>
          <button className={cn(styles.button, styles.inverted)} onClick={onClear}>
            <CrossIcon />
            {t('Clear')}
          </button>
          <button className={styles.button} onClick={onPreview}>
            <EyeIcon />
            {t('Preview')}
          </button>
        </div>
      </div>
    </div>
  )
}

export default InvoiceFooter
